// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1acQY","messages":"Chat_messages__1MC4m","dateDivider":"Chat_dateDivider__2lBZd"};